'use client';
import { jsx } from 'react/jsx-runtime';
import cl from 'clsx/lite';
import { forwardRef, useContext } from 'react';
import { Label } from '../label/label.js';
import { ComboboxContext } from './ComboboxContext.js';

const ComboboxEmpty = forwardRef(({ children, className, ...rest }, ref) => {
    const context = useContext(ComboboxContext);
    if (!context) {
        throw new Error('ComboboxEmpty must be used within a Combobox');
    }
    const { filteredOptions, size } = context;
    return (filteredOptions.length === 0 && (jsx(Label, { "data-size": size, asChild: true, children: jsx("div", { ref: ref, className: cl('ds-combobox__empty', className), ...rest, children: children }) })));
});
ComboboxEmpty.displayName = 'ComboboxEmpty';

export { ComboboxEmpty };
